import React from "react";

import { AiOutlineSearch } from "react-icons/ai";

import "./Banner.css";
const Banner = () => {
    return (
        <>
            <div className="hero">
                <div className="content">
                    <h1>Mobile Repairing Tools</h1>
                    <p className="search-text">
                        {" "}
                        Best Mobile Tools Manufacturers All Over The World.
                        Every Product Made With Best Quality.{" "}
                    </p>
                </div>
            </div>
        </>
    );
};

export default Banner;
